export const IDEAL_PAYMENT_FAILED_MESSAGE =
  "exhibitor.cart.payment.not_completed_no_charge";
